import instance from "./configAxios";

export async function createGroup(token, data) {
    try {
        const config = {
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            }
        }

        // data = desc_grupo

        const response = await instance.post('/insert-grupo_usuario', data, config);

        return response;
    } catch (error) {
        console.log('createGroup -> Error en el servidor:', error);

        return error
    }
};

export async function updateGroup(token, data) {
    try {
        const config = {
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            }
        }

        // data = idgrupo, desc_grupo

        const response = await instance.put('/update-grupo_usuario', data, config);

        return response;
    } catch (error) {
        console.log('updateGroup -> Error en el servidor:', error);

        return error;
    }
};

export async function deleteGroup(token, data) {
    try {
        const config = {
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            }
        }

        // data = idgrupo

        const response = await instance.put('/delete-grupo_usuario', data, config);

        return response;
    } catch (error) {
        console.log('deleteGroup -> Error en el servidor:', error);

        return error;
    }
};